import styled from '@emotion/styled/macro';
import { em } from 'polished';

export const AuthContainerWrapper = styled.div({
  textAlign: 'center',
  color: 'rgb(0, 160, 255)',
  padding: em(24)
});
